'use client';

import React from 'react';
import Link from 'next/link';
import { trackAdobeClick, ClickType } from '@/utils/adobe';

export interface TrackedLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  clickName: string;
  clickType?: ClickType;
  clickLocation?: string;
}

// A next/link that fires an Adobe Click event — for plain (non-CTA) links rendered by server components
export const TrackedLink = ({
  href,
  clickName,
  clickType,
  clickLocation,
  onClick,
  children,
  ...rest
}: React.PropsWithChildren<TrackedLinkProps>) => {
  // Track the click, then run any caller-supplied handler
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    trackAdobeClick({ clickName, clickType, clickLocation }, e);
    onClick?.(e);
  };

  return (
    <Link href={href} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
};
